import { gql } from 'graphql-request'

export const REMOVE_STICKER_LIST = gql`
  mutation RemoveStickerSelecting($ids: [Int!]!) {
    removeStickerSelecting(ids: $ids) {
      id
    }
  }
`
